import React from "react";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineArrowUp,
  AiFillLinkedin,
  AiFillYoutube,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <img
          src={"https://avatars.githubusercontent.com/u/116056012?s=400&u=08f47a7eaf78143031b7fea2f6624adfa00aea2c&v=4"}
          alt="Founder"
        />

        <h2>Bhanu Prakash Jha</h2>
        <p>I want to be your that friend on whom you can Trust.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a href="https://github.com/bhanu567" target={"blank"}>
            <AiFillGithub />
          </a>
          <a href="https://www.youtube.com/@bhanuprakashjha7035" target={"blank"}>
            <AiFillYoutube />
          </a>
          <a href="https://instagram.com/bhanu_prakash_jha" target={"blank"}>
            <AiFillInstagram />
          </a>
          <a href="https://www.linkedin.com/in/bhanu-prakash-jha-2a80331a2/">
            <AiFillLinkedin />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
